module.exports = __webpack_public_path__ + "static/media/VictorAparici.ebebbdac.jpg";